import { ListConsultations } from './list-consultations';

export default ListConsultations;